import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router';

/**
 * Start every newly opened page at the top.
 *
 * The router swaps the page in place, so without this the window keeps the
 * previous page's scroll offset — on a phone, "Back to games" from the bottom
 * of a long page lands halfway down the hub. Browser back/forward (`POP`) is
 * left alone so the browser can restore where the player was.
 */
export function ScrollToTop(): null {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, navigationType]);

  return null;
}
